import React from 'react';

export const FormsContext = React.createContext({
  form_tags: [],
  product_groups: []
});
